export class GuidUtils {
    guid;
    _guid;
    constructor(guid) {
        this.guid = guid;
        this._guid = guid;
    }
    // Static member
    static MakeNew() {
        let result;
        let i;
        let j;
        result = "";
        for (j = 0; j < 32; j++) {
            if (j === 8 || j === 12 || j === 16 || j === 20)
                result = result + "-";
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return new GuidUtils(result);
    }
    ToString() {
        return this.guid;
    }
}
